{
	"name": "@cloudillo/pagillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Pagillo collaborative page layout and publishing",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"ts": "tsgo --noEmit",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"test": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"test:watch": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --watch",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilard Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/canvas-tools": "workspace:^",
		"@cloudillo/core": "workspace:^",
		"@cloudillo/crdt": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@cloudillo/types": "workspace:^",
		"@cloudillo/typeset": "workspace:^",
		"@jest/globals": "^30.5.2",
		"@symbion/opalui": "^0.16.0",
		"@types/jest": "^30.0.0",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"cross-env": "^10.1.0",
		"dictionary-de": "^3.0.0",
		"dictionary-en": "^4.0.0",
		"dictionary-hu": "^3.0.0",
		"esbuild": "^0.28.2",
		"fake-indexeddb": "^6.2.5",
		"harfbuzzjs": "1.6.3",
		"hunspell-wasm": "0.3.0",
		"i18next": "^26.4.2",
		"jest": "^30.5.2",
		"jest-environment-jsdom": "^30.5.2",
		"pdfkit": "0.20.1",
		"react": "19.3.0",
		"react-dom": "19.3.0",
		"react-i18next": "^17.0.15",
		"react-icons": "^5.7.0",
		"react-router-dom": "^7.18.4",
		"rimraf": "^6.1.3",
		"ts-jest": "^29.4.14",
		"tslib": "^2.8.1",
		"typescript": "npm:@typescript/typescript6@^6.0.2",
		"yjs": "^13.6.33"
	}
}
